export const ilstates =[
    {
        "abbreviation": "35",
        "city": "Port Blair",
        "name": "Andaman and Nicobar Islands",
        "pincode": 744101
      },
      {
        "abbreviation": "37",
        "city": "Amaravati",
        "name": "Andhra Pradesh",
        "pincode": 521225
      },
      {
        "abbreviation": "12",
        "city": "Itanagar",
        "name": "Arunachal Pradesh",
        "pincode": 791111,
      },
      {
        "abbreviation": "18",
        "city": "Dispur",
        "name": "Assam",
        "pincode": 781005,
      },
      {
        "abbreviation": "10",
        "city": "Patna",
        "name": "Bihar",
        "pincode": 800001,
      },
      {
        "abbreviation": "4",
        "city": "Chandigarh",
        "name": "Chandigarh",
        "pincode": 160001,
      },
      {
        "abbreviation": "22",
        "city": "Naya Raipur",
        "name": "Chattisgarh",
        "pincode": 492015, 

      },
      {
        "abbreviation": "25",
        "city": "Daman",
        "name": "Dadra and Nagar Haveli",
        "pincode": 396210,
      },
      {
        "abbreviation": "DD",
        "city": "Damanu",
        "name": "Daman and Diu",
        "pincode": 396210,
      },
      {
        "abbreviation": "7",
        "city": "New Delhi",
        "name": "Delhi",
        "pincode": 110001,
      },
      {
        "abbreviation": "30",
        "city": "Panaji",
        "name": "Goa",
        "pincode": 403001,
      },
      {
        "abbreviation": "24",
        "city": "Gandhinagar",
        "name": "Gujarat",
        "pincode": 382001,
      },
      {
        "abbreviation": "6",
        "city": "Chandigarh",
        "name": "Haryana",
        "pincode": 160001,
      },
      {
        "abbreviation": "2",
        "city": "Shimla",
        "name": "Himachal Pradesh",
        "pincode": 171001,
      },
      {
        "abbreviation": "1",
        "city": "Srinagar",
        "name": "Jammu and Kashmir",
        "pincode": 190001,
      },
      {
        "abbreviation": "20",
        "city": "Ranchi",
        "name": "Jharkhand",
        "pincode": 834001,
      },
      {
        "abbreviation": "29",
        "city": "Bangalore",
        "name": "Karnataka",
        "pincode": 560001,
      },
      {
        "abbreviation": "32",
        "city": "Thiruvananthapuram",
        "name": "Kerala",
        "pincode": 695001,
      },
      {
        "abbreviation": "31",
        "city": "Kavaratti",
        "name": "Lakshadweep",
        "pincode": 682555,
      },
      {
        "abbreviation": "23",
        "city": "Bhopal",
        "name": "Madhya Pradesh",
        "pincode": 462001,
      },
      {
        "abbreviation": "27",
        "city": "Mumbai",
        "name": "Maharashtra",
        "pincode": 400001,
      },
      {
        "abbreviation": "14",
        "city": "Imphal",
        "name": "Manipur",
        "pincode": 795001,
      },
      {
        "abbreviation": "17",
        "city": "Shillong",
        "name": "Meghalaya",
        "pincode": 793001,
      },
      {
        "abbreviation": "15",
        "city": "Aizawl",
        "name": "Mizoram",
        "pincode": 796001,
      },
      {
        "abbreviation": "13",
        "city": "Kohima",
        "name": "Nagaland",
        "pincode": 797001,
      },
      {
        "abbreviation": "21",
        "city": "Bhubaneswar",
        "name": "Odisha",
        "pincode": 751001,
      },
      {
        "abbreviation": "34",
        "city": "Puducherry",
        "name": "Puducherry",
        "pincode": 605001,
      },
      {
        "abbreviation": "3",
        "city": "Chandigarh",
        "name": "Punjab",
        "pincode": 160001,
      },
      {
        "abbreviation": "8",
        "city": "Jaipur",
        "name": "Rajasthan",
        "pincode": 302001,
      },
      {
        "abbreviation": "11",
        "v": "Gangtok",
        "name": "Sikkim",
        "pincode": 737101,
      },
      {
        "abbreviation": "33",
        "city": "Chennai",
        "name": "Tamil Nadu",
        "pincode": 600001,
      },
      {
        "abbreviation": "36",
        "city": "Hyderabad",
        "name": "Telangana",
        "pincode": 500001,
      },
      {
        "abbreviation": "16",
        "city": "Agartala",
        "name": "Tripura" ,
        "pincode": 799001,
      },
      {
        "abbreviation": "9",
        "city": "Lucknow",
        "name": "Uttar Pradesh",
        "pincode": 226001,
      },
      {
        "abbreviation": "5",
        "city": "Dehradun",
        "name": "Uttarakhand",
        "pincode": 248001,
      },
      {
        "abbreviation": "19",
        "city": "Kolkata",
        "name": "West Bengal",
        "pincode": 700001,
      }
]